import { type PrimitiveProps } from '@react-three/fiber';
import { type JoyConModel, GLTFModel } from '@billykwok/3d';

import { AnimatedPrimitive } from '@/utils/react-three-fiber/animations';
import { useGLTF } from '@/utils/react-three-fiber/useGLTF';

const modelPath = `/models/${GLTFModel.JoyCon}`;

export function AnimatedJoyCon(props: Partial<PrimitiveProps>) {
  const { scene } = useGLTF<JoyConModel, string>(modelPath);
  return <AnimatedPrimitive object={scene} dispose={null} {...props} />;
}

useGLTF.preload(modelPath);
